module.exports = __webpack_public_path__ + "img/dms3.a770541f.svg";